import React from 'react';
import { Trash } from '@phosphor-icons/react';
import { Button, Dropdown } from 'app/components';
import Form from './form';

const SubQuestionBuilder = (props) => {
  const {
    conditions,
    options,
    onAddSubQuestion,
    onChange,
  } = props;

  const onChangeCondition = (key, value, index, type = null) => {
    const updatedOptions = [...(conditions || [])];
    updatedOptions[index] = {
      ...updatedOptions?.[index], 
      ...(type === 'config' ? { 
        config: {
          ...updatedOptions?.[index]?.config,
          [key]: value,
        },
      } : {
        [key]: value,
      }),
    };
    onChange('conditions', updatedOptions);
  };

  const onDelete = (index) => {
    const updatedOptions = [...(conditions || [])];
    updatedOptions.splice(index, 1);
    onChange('conditions', updatedOptions);
  };

  return (
    <div className="flex flex-col gap-8 pl-12 mt-8">
      {conditions?.map((condition, index) => (
        <div className="flex flex-col gap-5">
          <div className="flex items-center gap-3">
            <div className="heading-24">Sub question - {index + 1}</div>
            <Trash
              color="#101010"
              className="cursor-pointer"
              size={20}
              onClick={() => onDelete(index)}
            />
          </div>
          <Dropdown
            label="If the attendee chooses"
            placeholder="Select Option"
            options={options?.map(({ value, id }) => ({ label: value, id }))}
            value={condition?.choice}
            onChange={(value) => onChangeCondition('choice', value, index)}
            width="100%"
          />
          <Form
            formConfig={condition?.config}
            onChange={(key, value) => onChangeCondition(key, value, index, 'config')}
            allowSubQuestion={false}
          />
        </div>
      ))}
      <Button
        type="tertiary"
        onClick={onAddSubQuestion}
      >
        Add another sub question
      </Button>
    </div>
  );
};

export default SubQuestionBuilder;
